const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  mId: state => state.user.mId,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  cardTypeDice: state => state.user.cardTypeDice,
  roles: state => state.user.roles,
  isModuleSign: state => state.user.isModuleSign,
  buttons: state => state.user.buttons,
  buttonName: state => state.user.buttonName,
  permission_routes: state => state.permission.routes,
  reportingType: state => state.user.reportingType,
  //  常规任务的开启
  routineTaskOpen: state => state.user.agreement.routineTaskOpen,
  // 派单任务 新业态任务
  businessModel: state => state.user.agreement.businessModel,
  outTradeChannelConfig: state => {
    if (!state.user.outTradeChannelConfig) {
      return {
        funSupportAppletQRCode: 1,
        funSupportCommonH5Link: 1,
        funSupportCommonH5QRCode: 1,
        funSupportPrivateH5Link: 1,
        funSupportServiceSign: 1
      };
    }
    return state.user.outTradeChannelConfig;
  },
  // 当前签署服务商ID
  taxId: state => state.user.taxId
};
export default getters;
